import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../../../services/app-config.service";

@Injectable({
    providedIn: 'root'
})
export class AttachmentService {
    httpOptions: any = {
        Headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    mediaHttpOptions: any = {
        Headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' })
    };

    mediaResponseType: any = {
        Headers: new HttpHeaders({ }) , responseType: 'blob', observe: 'response'
    }

    apiUrl = AppConfig.settings.apiUrl;
    AttachmentAPIConstant = `Attachments`;

    constructor(private httpClient: HttpClient) {
    }

    saveAttachment(file: FormData) {
        return this.httpClient.post(`${this.apiUrl}${this.AttachmentAPIConstant}/Create`, file, this.httpOptions);
    }

    saveAttachments(file: FormData) {
        return this.httpClient.post(`${this.apiUrl}${this.AttachmentAPIConstant}/Upload-Multiple`, file, this.httpOptions);
    }

    getAttachment(fileName: string) {
        return this.httpClient.get(`${this.apiUrl}${this.AttachmentAPIConstant}/${fileName}`, this.mediaResponseType);
    }

    deleteAttachment(fileName: string) {
        return this.httpClient.delete(`${this.apiUrl}${this.AttachmentAPIConstant}/${fileName}`, this.httpOptions);
    }

    getTemplate(templateName: string){
        return this.httpClient.get(`${this.apiUrl}${this.AttachmentAPIConstant}/GetTemplate/${templateName}`, this.mediaResponseType);
    }
}
